import api from './api';

export const staffPaymentApi = {
  getStaff: () => api.get('/api/vendor/finance/staff'),
  createStaff: (data: Record<string, unknown>) => api.post('/api/vendor/finance/staff', data),
  updateStaff: (id: number, data: Record<string, unknown>) => api.put(`/api/vendor/finance/staff/${id}`, data),
  deleteStaff: (id: number) => api.delete(`/api/vendor/finance/staff/${id}`),
  getStaffPayments: (id: number, params?: Record<string, unknown>) =>
    api.get(`/api/vendor/finance/staff/${id}/payments`, { params }),
  getStaffSummary: (params?: Record<string, unknown>) => api.get('/api/vendor/finance/staff/summary', { params }),
};
